const collection = {
    slug: "flower_existence",
    metaTitle:
      "COMME des GARÇONS HOMME PLUS 2022SS 花の存在｜Enclopedia Archive Study",
    metaDescription:
      "COMME des GARÇONS HOMME PLUS 2022SS『花の存在』を、素材の対比、色彩の流れ、コレクション全体の構成から読み解くEnclopediaのアーカイブ解説ページです。",
    metaKeywords:
      "COMME des GARCONS HOMME PLUS 2022SS,花の存在,コムデギャルソンオムプリュス,アーカイブファッション,コレクション解説,enclopedia,アンクロペディア",
    canonicalPath: "/archive_collection/comme_des_garcons_homme_plus_2022ss_flower_existence",
    heroImage: "media/collection/archive1.png",
    heroImageAlt:
      "COMME des GARÇONS HOMME PLUS 2022SS 花の存在のアーカイブコレクション画像",
    heroNumber: "01 / FLOWER",
    label: "ARCHIVE COLLECTION STUDY",
    title: "COMME des GARÇONS HOMME PLUS 2022SS『花の存在』",
    lead:
      "花を幸福の記号として消費するのではなく、美しさと儚さ、癒やしと痛みを同時に引き受ける存在として捉え直したコレクション。\nEnclopediaでは、花柄という分かりやすい視覚の奥にある素材構成とランウェイ全体の流れを読み解きます。",
    keywordLine: ["flower", "contrast", "military", "full bloom"],
    thesis:
      "このコレクションの核は、花の美しさと儚さを、素材・色彩・ショー全体の構成によって同時に見せた点にあります。",
    whyTitle: "花は、なぜここまで強い存在として現れたのか。",
    whyBody:
      "2022SSのHOMME PLUSでは、花は単なる装飾ではありません。異素材とぶつかり、無骨な服の構造へ入り込み、ショー全体の色彩変化の中で徐々に咲き切っていく。\nその見せ方を追うことで、『花の存在』というテーマが服の上でどう成立していたかが見えてきます。",
    pillars: [
      {
        number: "01",
        title: "FLOWER AS PRESENCE",
        text:
          "花を“飾り”として置くのではなく、服全体の印象を変える存在として扱う。花柄そのものがコレクションの主題へ押し上げられています。",
      },
      {
        number: "02",
        title: "MATERIAL CONTRAST",
        text:
          "白黒の花柄生地を黒いフェイクレザーに重ねることで、柔らかさと硬さが衝突する。花の繊細さは、その緊張の中でより鮮明になります。",
      },
      {
        number: "03",
        title: "RUNWAY AS BLOOM",
        text:
          "モノトーンからピンクを含む色彩へ。ショー全体が、花が咲き、満開へ向かう過程のように構成されているようにも見えます。",
      },
    ],
    readingTitle: "ルックとディテールから読む、花の美しさと儚さ。",
    readingIntro:
      "花の存在を理解するうえで重要なのは、“柄がある”ことではなく、“どこに、何と合わせて、どの順序で現れるか”を見ることです。",
    observations: [
      {
        index: "01",
        title: "モノトーンの花柄 × 黒いフェイクレザー",
        text:
          "柔らかな有機性を持つ花柄と、人工的で硬質なレザー感を並置することで、花は守られるのではなく、緊張の中で浮かび上がります。美しさが強まるほど、同時に壊れやすさも見えてくる構成です。",
      },
      {
        index: "02",
        title: "カーキのミリタリーを花柄で切り替える",
        text:
          "無骨さや機能性を担うミリタリーウェアに花柄を差し込むことで、花は弱い装飾ではなく、強い服の意味を変えてしまう存在になります。",
      },
      {
        index: "03",
        title: "モノトーンからピンクへ向かう色の流れ",
        text:
          "序盤は抑制された色から始まり、終盤にかけて花を象徴する色彩が強まっていく。満開は最も美しい瞬間であると同時に、終わりに最も近い瞬間でもある。その二重性がテーマと響き合います。",
      },
    ],
    quote:
      "花は、明るい場面だけのための記号ではない。だからこそこのコレクションでは、華やかさと儚さが同じ強度で立ち上がる。",
    perspectiveTitle: "Enclopediaは、このコレクションを“知識”と“体験”の両方から開く。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "なぜ花なのか。なぜフェイクレザーやミリタリーとぶつけるのか。単なる商品説明ではなく、テーマと服の関係まで可視化します。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "柄の密度、素材の厚み、身体に乗せたときの緊張感は、画像だけでは掴みきれません。レンタルをコレクション体験として設計します。",
      },
      {
        number: "03",
        title: "COMMUNITY",
        text:
          "ギャルソンを詳しく知らなかった人も、花という入口から読み始められる。愛好家・学生・スタイリストが共有できる文脈を育てます。",
      },
    ],
    experienceTitle: "画像で見るだけでは終わらない。実物で、テーマを確かめる。",
    experienceBody:
      "Enclopediaでは、アーカイブを“所有前の試着”に閉じず、服を理解するための体験として扱います。\n花柄の密度、異素材の重さ、着用時の視線の動きまで含めて、このコレクションの魅力に触れられる導線を作ります。",
    experienceItems: [
      "花柄の密度と配置を実物で見る",
      "フェイクレザーとの素材差を触れて理解する",
      "コレクション背景を知ったうえでレンタルする",
    ],
    archiveItemsTitle: "このテーマを、実物で確かめる。",
    archiveItemsBody:
      "在庫導線には、単なる商品カードではなく、“このアイテムのどこを見るべきか”を添える想定です。知識の続きとして商品ページへ進める構成にします。",
    archiveItems: [
      {
        label: "ARCHIVE FOCUS 01",
        title: "Flower × Leather Contrast",
        productPath: "/product/34df6c1d-1b52-45c4-afc3-070b5a46c965",
        productImage:
          "media/product/1760259569.56001334df6c1d-1b52-45c4-afc3-070b5a46c965.jpg",
        text:
          "花柄と黒い質感の衝突を見るための導線。柔らかさが硬質さによって強調される構成を体験できます。",
      },
      {
        label: "ARCHIVE FOCUS 02",
        title: "Military × Floral Reconstruction",
        productPath: "/product/f9dc5b09-8bb5-4828-8d52-ffc553a96ace",
        productImage:
          "media/product/1730183983.8211675f9dc5b09-8bb5-4828-8d52-ffc553a96ace.jpg",
        text:
          "無骨な服の骨格へ花が入り込むことで、印象がどう変わるかを読み解く導線。",
      },
      {
        label: "ARCHIVE FOCUS 03",
        title: "Pink as Full Bloom",
        productPath: "/product/86db861c-951b-47ef-bf45-fc7c33fb2524",
        productImage:
          "media/product/1768918935.165018386db861c-951b-47ef-bf45-fc7c33fb2524.jpg",
        text:
          "ショー終盤の“開花のピーク”を想起させる、色彩と存在感に着目した導線。",
      },
    ],
  };

export default collection;
